<template>
  <div class="v-expandable-block__wrapper" :class="{ [extraClass]: true }">
    <div
      class="header"
      :class="{ ['expanded']: expanded, ['not-expandable']: notExpandable }"
      @click="toggleExpand"
    >
      <span> {{ header }} </span>
      <div class="expand" v-if="!notExpandable">
        <i :class="getFaClass"> </i>
      </div>
    </div>

    <div v-show="expanded" class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VExpandableBlock", {
  props: {
    header: VueTypes.string.isRequired,
    expandOnLoad: VueTypes.bool.def(false),
    extraClass: VueTypes.string.def(""),
    notExpandable: VueTypes.bool.def(false)
  },

  data() {
    return {
      expanded: this.expandOnLoad
    };
  },

  methods: {
    toggleExpand() {
      if (!this.notExpandable) {
        this.expanded = !this.expanded;
      }
    }
  },

  computed: {
    getFaClass() {
      return `fa fa-caret-${this.expanded ? "up" : "down"}`;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-expandable-block";

.#{$ns} {
  &__wrapper {
    border: 1px solid #cacaca;
    transition: height 0.2s linear;
    padding: 14px;

    .header {
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      font-family: "Hind-Regular", Arial, sans-serif;

      &.expanded {
        margin-bottom: 22px;
      }

      &.not-expandable {
        cursor: default;
      }

      .expand {
        color: #7c8ca3;
        font-size: 21px;
        opacity: 0.6;
      }
    }
  }
}
</style>
